module.exports = __webpack_public_path__ + "5e2dd181a12d7562aa41023c458ac8c3.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/cape-black-s.png
// module id = 1814
// module chunks = 0